import { Button, Disclaimer, Icon, Show, Spacer } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { BeteiligungenContentRow, FunktionsGrid } from 'components/profiles';
import { useRouter } from 'next/router';
import React from 'react';
import { Referenz, ReferenzType } from 'types';
import { UnternehmenDto } from 'types/unternehmen';
import { copyQuery, scrollToAnchor } from 'utils';
import { usePlusPage, useTranslation } from 'utils/hooks';

interface OrganeProps 
{
  unternehmen: UnternehmenDto;
}

const OrganeUndNetzwerk: React.FC<OrganeProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');
  const isPlusPage = usePlusPage();
  const router = useRouter();

  const origin: Referenz = {
    id: unternehmen.fbNr,
    name: unternehmen.name,
    type: ReferenzType.Unternehmen,
    isIndexed: false,
  };

  const renderFullscreenButton = (page: 'leitungsorgane' | 'kontrollorgane' | 'prokura') => (
    <div style={{ margin: '0.5rem 0' }}>
      <Button
        variant="secondary"
        onClick={isPlusPage
          ? () => router.push({ pathname: router.pathname + '/' + page, query: copyQuery(router.query, ['id', 'token']) })
          : () => scrollToAnchor('plus-inhalte', -100)
        }
      >
        <Icon name={isPlusPage ? 'maximize' : 'lock'} />
        {t('profiles:actions.openFullscreen')}
      </Button> 
    </div>
  );
  
  return (
    <>

      {/* Workaround -> Detailsuche weiß nicht ob die Prokura extra ist oder nicht,
          daher ein leeres Element mit ID für deep linking */}
      <Show when={!unternehmen.prokuraorgane}>
        <div id="prokura" />
      </Show>

      {/* Leitungsorgane */}
      <Show when={unternehmen.wortlaute[unternehmen.wortlaute.length - 1].item.isCoKg}>
          <Spacer height={1} />
          <Disclaimer text={t('profiles:unternehmen.leitungsorgane.disclaimer')} />
          <Spacer height={1} />
      </Show>
      {!!unternehmen.leitungsorgane && (
        <ContentRow
          id="personen"
          title={t('profiles:unternehmen.leitungsorgane.label')}
          actionRenderer={() => renderFullscreenButton('leitungsorgane')}
        >
          <FunktionsGrid data={unternehmen.leitungsorgane} />

        </ContentRow>
      )}

      {/* Netzwerk */}
      {Object.keys(unternehmen.netzwerk).length > 0 && (
        <BeteiligungenContentRow
          key={`netzwerk_${unternehmen.fbNr}`}
          title={t('profiles:unternehmen.netzwerk.label')}
          netzwerk={unternehmen.netzwerk}
          origin={origin}
          inconsistent={unternehmen.fbInconsistency}
          allowExtendedView={unternehmen.status !== 'Gelöscht'}
          tier={unternehmen.tier}
        />
      )}

      {/* Kontrollorgane */}
      {!!unternehmen.kontrollorgane && (
        <ContentRow
          id="aufsichtsrat"
          title={t('profiles:unternehmen.kontrollorgane.label')}
          actionRenderer={() => renderFullscreenButton('kontrollorgane')}
        >
          <FunktionsGrid data={unternehmen.kontrollorgane} />
        </ContentRow>
      )}

      {/* Prokura */}
      {!!unternehmen.prokuraorgane && (
        <ContentRow 
          id="prokura"
          title={t('profiles:unternehmen.prokura.label')}
          actionRenderer={() => renderFullscreenButton('prokura')}
        >
          <FunktionsGrid data={unternehmen.prokuraorgane} />
        </ContentRow>
      )}

    </>
  );
};

export default OrganeUndNetzwerk;
